import { useBooleanFlagValue } from '@openfeature/react-sdk';

import { useAgentVisibility } from '@/entities/agent';
import { getCurrentOrganizationId } from '@/entities/user';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import { REELS_CREATOR_TOOL_ID } from '@/shared/utils/reels-creator';

export interface ReelsCreatorAllowed {
  isAllowed: boolean;
  isLoading: boolean;
}

/**
 * The single gate for the in-app Reels Creator: the tile, the routes and the guard all read
 * this hook, so the rollout flag and the per-workspace ACL cannot disagree between them.
 * `isLoading` is separate from `isAllowed` so a consumer can hold back rather than act on
 * the `false` that an in-flight ACL check reads as.
 */
export const useReelsCreatorAllowed = (): ReelsCreatorAllowed => {
  const workspaceId = useCurrentWorkspaceId();
  const organizationId = getCurrentOrganizationId();
  const isFlagEnabled = useBooleanFlagValue('reels_creator', false);
  const { isAgentEnabled, isLoading } = useAgentVisibility([REELS_CREATOR_TOOL_ID], {
    workspaceId,
    organizationId,
  });

  return {
    isAllowed: isFlagEnabled && isAgentEnabled(REELS_CREATOR_TOOL_ID),
    // With the flag off the answer is already no, whatever the ACL says.
    isLoading: isFlagEnabled && isLoading,
  };
};
